import { useState, useEffect } from 'react';
import { XCircle } from 'lucide-react';

const FeedbackCTA = ({ onClick }) => {
  const [isVisible, setIsVisible] = useState(false);

  // Show CTA after 5 minutes of usage
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 5 * 60 * 1000);
    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed right-0 top-1/2 transform -translate-y-1/2 z-50">
      <div className="relative">
        <button
          onClick={() => setIsVisible(false)}
          className="absolute -left-2 -top-2 text-gray-500 hover:text-gray-700"
        >
          <XCircle className="h-5 w-5" />
        </button>
        <button
          onClick={onClick}
          className="bg-blue-600 text-white px-4 py-3 rounded-l-lg shadow-lg hover:bg-blue-700 transition-all duration-200 transform hover:translate-x-1 writing-mode-vertical"
          style={{ writingMode: 'vertical-rl' }}
        >
          Rate Your Experience
        </button>
      </div>
    </div>
  );
};

export default FeedbackCTA; 